import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/demo/_layout/settings')({
  component: () => <></>,
})
